<p class="title">
  {{ 'MANAGE_VACATIONS.RESUME_TEXT_1' | translate : { number: 4 } }}
  <b> {{ 'MANAGE_VACATIONS.' + selectedSeason.id | uppercase | translate | lowercase }}</b
  >{{ 'MANAGE_VACATIONS.RESUME_TEXT_2' | translate }}
</p>
<app-proposal-card [proposal]="proposal" [canEdit]="false" [showEmptyProposals]="false"></app-proposal-card>
